<template>
  <div>
    <div class="preview-form-parent" id="checkin-form">
      <div class="row">
        <div class="col-8 center-block text-center">
          <span
            >{{ $t("input.step") }} {{ step }} {{ $t("input.of") }}
            {{ steps }}</span
          >
          <h3>
            <span v-if="activeStep === 'info'">{{ form.description }}</span>
            <span v-if="activeStep === 'passport'">{{
              $t("booking.detail.form.upload_password_desc")
            }}</span>
            <span v-if="activeStep === 'card'">{{
              $t("booking.detail.form.upload_credit_card_desc")
            }}</span>
          </h3>
        </div>
      </div>
      <div v-if="activeStep === 'passport'" class="instructions-upload">
        <h2>{{ $t("booking.detail.form.passport_selfie_title") }}</h2>
        <p>{{ $t("booking.detail.form.passport_selfie_desc") }}</p>
      </div>
      <div v-if="activeStep === 'card'" class="instructions-upload">
        <h2>{{ $t("booking.detail.form.card_selfie_title") }}</h2>
        <p>{{ $t("booking.detail.form.card_selfie_desc") }}</p>
      </div>
      <v-form-details
        v-if="activeStep === 'info'"
        :booking="booking"
        :timeInHours="timeInHours"
        :timeOutHours="timeOutHours"
      />
      <v-upload-passport
        v-if="activeStep === 'passport'"
        :booking="booking"
        @onUploadFileChange="onUploadFileChange"
        @removeResource="removeResource"
      />
      <v-upload-credit-card
        v-if="activeStep === 'card'"
        :booking="booking"
        @onUploadFileChange="onUploadFileChange"
        @removeResource="removeResource"
      />
      <v-loading
        :isLoading="smallLoading"
        :height="50"
        :width="50"
        :viewbox="'0 0 50 50'"
        :cx="25"
        :cy="25"
        :r="22"
        :isHeightAuto="true"
      ></v-loading>
      <div
        class="checkin-form-footer"
        :class="
          activeStep === 'info'
            ? 'justify-content-end'
            : 'justify-content-between'
        "
      >
        <button
          v-if="activeStep !== 'info'"
          class="btn waves-effect waves-classic btn-cancel"
          @click.prevent="previous"
          :disabled="smallLoading"
        >
          {{ $t("button.previous") }}
        </button>
        <button
          class="btn btn-red send-button"
          @click.prevent="next"
          :disabled="smallLoading"
        >
          {{ $t("button.next") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import bookingService from "../../../../services/booking";
import mixin from "../../../../mixins/mixin";
import fileService from "../../../../services/file";

export default {
  name: "CheckinForm",
  data() {
    return {
      activeStep: "info",
      smallLoading: false,
      passportResource: false,
      cardResource: false,
      step: 1,
      dataUpdated: false,
    };
  },

  props: ["booking", "form", "timeInHours", "timeOutHours", "steps"],

  mixins: [mixin],

  components: {
    VFormDetails: require("./FormDetails"),
    VUploadPassport: require("./UploadPassport"),
    VUploadCreditCard: require("./UploadCreditCard"),
    VLoading: require("components/loading/loading.vue"),
  },

  methods: {
    async next() {
      this.smallLoading = true;

      if (this.activeStep === "info") {
        await this.updateDetails();
        if (this.dataUpdated) {
          await this.updateStep("passport");
        }
        this.smallLoading = false;
      } else if (this.activeStep === "passport") {
        await bookingService.checkBookingResource(
          this,
          this.$route.params.booking_permalink,
          "passport"
        );
        if (this.passportResource) {
          await this.updateStep("card");
        }
        this.smallLoading = false;
      } else if (this.activeStep === "card") {
        await bookingService.checkBookingResource(
          this,
          this.$route.params.booking_permalink,
          "card"
        );
        if (this.cardResource) {
          await this.updateStep("card");
        }
      }
    },

    async updateDetails() {
      const data = {
        alternative_email: this.booking.guest.alternative_email,
        alternative_phone: this.booking.guest.alternative_phone,
        time_in: this.booking.time_in,
        time_out: this.booking.time_out,
        extra_data_from_form: this.booking.extra_data_from_form,
      };
      await bookingService.updateDetails(
        this,
        this.$route.params.booking_permalink,
        data
      );
    },

    async onUploadFileChange(event, type) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) {
        return;
      }

      let formData = new FormData();

      formData.append("image", files[0]);
      formData.append("folder", "forms");
      formData.append("type", type);

      await fileService.uploadResource(
        this,
        this.$route.params.booking_permalink,
        formData
      );
      await this.$emit("getBooking");
    },

    redirectToPath() {
      let href = document.createElement("a");
      if (this.form.redirect_type === "url") {
        if (
          this.form.redirect_url.match("https://") ||
          this.form.redirect_url.match("http://")
        ) {
          href.href = this.form.redirect_url;
        } else {
          href.href = `https://${this.form.redirect_url}`;
        }
      } else {
        href.href = this.form.redirect_file;
      }
      href.click();
    },

    async removeResource(id) {
      await fileService.removeResource(this, id);
      await this.$emit("getBooking");
    },

    previous() {
      if (this.step > 1) {
        this.step--;
      }
      if (this.step === 1) {
        this.activeStep = "info";
      } else if (this.step === 2) {
        this.activeStep = "passport";
      }
    },

    async updateStep(type) {
      if (
        this.form.steps &&
        this.form.steps.length > 0 &&
        !this.form.steps.find((step) => step.type === type)
      ) {
        this.activeStep = type === "passport" ? "card" : "passport";
      } else {
        this.activeStep = type;
      }

      if (this.step === this.steps) {
        await bookingService.createCheckinFormSubmitNotification(
          this,
          this.$route.params.booking_permalink
        );
        await this.redirectToPath();
      }

      if (this.steps > this.step) {
        this.step++;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// CheckinForm.vue?4d3ddab7